import React from "react";
import { Box, Skeleton } from "@mui/material";

const CreditCardFormSkeleton = ({asMobile = false }) => {
  if (!asMobile) {
    return (
      <Box
        sx={{
          gap: "12px",
          flexDirection: "column",
          display: "flex",
        }}
      >
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
      </Box>
    );
  }
};

export default CreditCardFormSkeleton;
